import { render, staticRenderFns } from "./QuestionOval.vue?vue&type=template&id=297107c3&scoped=true"
import script from "./QuestionOval.vue?vue&type=script&lang=js"
export * from "./QuestionOval.vue?vue&type=script&lang=js"
import style0 from "./QuestionOval.vue?vue&type=style&index=0&id=297107c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297107c3",
  null
  
)

export default component.exports